/**
 * Maps hostnames to family slugs. When the app is served from a custom domain,
 * only the matching family is shown — nothing from other families leaks through.
 *
 * For local development or unknown domains, falls back to the user's first
 * membership.
 */

interface FamilyConfig {
  slug: string;
  name: string;
  logoAlt: string;
  /** Logo file in /public, keyed by variant. Null means use text fallback. */
  logo: { light: string | null; dark: string | null };
  /** Hero photo for the logged-out landing page (file in /public). Null
   *  falls back to a plain branded panel. */
  hero: string | null;
}

const DOMAIN_MAP: Record<string, FamilyConfig> = {
  "adgoy.com": { slug: "adgoy", name: "Adgoy", logoAlt: "Adgoy", logo: { light: "/adgoy-lion-light-web.png", dark: "/adgoy-lion-dark-web.png" }, hero: "/hero-adgoy.jpg" },
  "www.adgoy.com": { slug: "adgoy", name: "Adgoy", logoAlt: "Adgoy", logo: { light: "/adgoy-lion-light-web.png", dark: "/adgoy-lion-dark-web.png" }, hero: "/hero-adgoy.jpg" },
  "behailay.com": { slug: "behailay", name: "Behailay", logoAlt: "Behailay", logo: { light: "/behailay-crest-light-web.png", dark: "/behailay-crest-dark-web.png" }, hero: "/hero-behailay.jpg" },
  "www.behailay.com": { slug: "behailay", name: "Behailay", logoAlt: "Behailay", logo: { light: "/behailay-crest-light-web.png", dark: "/behailay-crest-dark-web.png" }, hero: "/hero-behailay.jpg" },
  // No bundled logo or hero yet — the app falls back to the text logotype and
  // a plain branded panel. Both are replaced by uploading in Settings.
  "adhanom.com": { slug: "adhanom", name: "Adhanom", logoAlt: "Adhanom", logo: { light: null, dark: null }, hero: null },
  "www.adhanom.com": { slug: "adhanom", name: "Adhanom", logoAlt: "Adhanom", logo: { light: null, dark: null }, hero: null },
};

export function getFamilyConfigForHost(
  hostname: string = window.location.hostname,
): FamilyConfig | null {
  return DOMAIN_MAP[hostname] ?? null;
}

export function getFamilySlugForHost(
  hostname: string = window.location.hostname,
): string | null {
  return DOMAIN_MAP[hostname]?.slug ?? null;
}
